module.exports = __webpack_public_path__ + "img/et.4995ccb2.png";